import { createStyles } from 'antd-style'

export const useStyle = createStyles({
  fallback: {
    minHeight: '100%',
    width: '100%',
    height: '100vh'
  }
})
